import { useState, useRef } from 'react';

import { ImgStyled, Content } from './img.styled';

export const Img = (props) => {
  const { src, title, afterError, realVideo = false, ...rest } = props;
  const [alt, setAlt] = useState(title);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [vertical, setVertical] = useState(false);
  const imgRef = useRef(null);

  const onLoad = () => {
    setError(false);
    setLoading(false);
    const w = imgRef.current.naturalWidth;
    const h = imgRef.current.naturalHeight;
    // console.log("w", w, h);
    setVertical(w < h);
  };

  const onError = () => {
    // setAlt('Ошибка загрузки');
    setLoading(false);
    setError(true);
    if (afterError) {
      setTimeout(() => {
        setError(false);
        afterError();
      }, 10000);
    }
  };

  const cl = `img-block ${loading ? ' loading' : error ? ' error' : ''} ${vertical ? ' vertical' : ''} ${realVideo ? ' real-video' : ''}`;

  return (
    <Content className={cl}>
      <ImgStyled src={src} alt={alt} title={alt} onLoad={onLoad} onError={onError} {...rest} ref={imgRef} />
    </Content>
  );
};
